import { createContext, useContext } from "react";

interface ITelegramContext {
    initData?: any;
    isTgAuth: boolean;
    tgId?: number;
}

export const TelegramContext = createContext<ITelegramContext>({
    isTgAuth: false,
});

export const useTelegramContext = (): ITelegramContext => {
    const context = useContext(TelegramContext);
    if (!context) {
        throw new Error('TelegramContext cannot be used outside the TelegramContext provider')
    }
    return context;
}
